// removed by extract-text-webpack-plugin
module.exports = {"DataTable":"DataTable__DataTable___2nulQ","DataTable_tdNameClient":"DataTable__DataTable_tdNameClient___2t9wd","DataTable_tdCeco":"DataTable__DataTable_tdCeco___3RksM","DataTable_tdNameStore":"DataTable__DataTable_tdNameStore___2DBlB","DataTable_tdTotalService":"DataTable__DataTable_tdTotalService___1v7dU","DataTable_thGlosa":"DataTable__DataTable_thGlosa___2WALk","DataTable_thNameStore":"DataTable__DataTable_thNameStore___XZKRt","DataTable_tdFinalTotals":"DataTable__DataTable_tdFinalTotals___ciJLf","DataTable_tdFinalTotalsText":"DataTable__DataTable_tdFinalTotalsText___3clXH"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/billing/management-oc/DataTable.css
// module id = 1142
// module chunks = 0